import axios from '../api-services/axios.instance';
import store from '../store';

import { config } from '../config';

let NumbersModel;
//let NumbersModelAxios;

NumbersModel = {};

axios.defaults.baseURL = config.$api_url;

NumbersModel.getNumbers = function(type, id) {
    
    //console.log('Numbers token: ' + localStorage.getItem('token'))

    switch (type) {
        case 'weekly':
            var numbersType = 'numbersByWeek';
            break;

        case 'monthly':
            var numbersType = 'numbersByMonth';
            break;

        case 'yearly':
            var numbersType = 'numbersByYear';
            break;

        default:
            var numbersType = 'numbers';
            break;
    }
    
    return new Promise((resolve, reject) => {
        axios.get('/api/' + numbersType + '/' + id)
            .then(resp => {
                store.dispatch('setNumbers', { type: type, data: resp.data.numbers }),
                resolve(resp)
            })
            .catch(err => {
                reject(err)
            })
    })

    /* axios.get(config.$api_url + '/api/' + numbersType + '/' + config.campaign_id).then(
        response => {
            return response.data.numbers;
        }
    ).catch(
        error => {
            console.log(error)
        }
    ); */
}

NumbersModel.getTokenOptions = function (id) {
    
    return new Promise((resolve, reject) => {
        axios.get(config.$api_url + '/api/to/' + id)
            .then(resp => {
                resolve(resp)
            })
            .catch(err => {
                reject(err)
            })
    })
}

NumbersModel.generateLuckyNumbersHistory = function (id, code) {
    //console.log('Getting number history');
    return new Promise((resolve, reject) => {
        axios.get('/api/gnh/' + id + '/' + code)
            .then(resp => {
                console.log('History API responded'),
                resolve(resp)
            })
            .catch(err => {
                console.log('Numbers History Error: ' + err),
                reject(err)
            })
    })
}

NumbersModel.generateLuckyNumbers = function (id, code) {

    return new Promise((resolve, reject) => {
        axios.get('/api/gn/' + id + '/' + code)
            .then(resp => {
                resolve(resp)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export { NumbersModel }


// WEBPACK FOOTER //
// ./src/models/numbers.js